<script setup>
  import { defineProps, computed } from 'vue'
import PokemonIcon from './PokemonIcon.vue';

const props = defineProps({
    tool: String,
    secondary: Boolean,
    tertiary: Boolean,
    small: Boolean,
    subdued: Boolean,
    disabled: Boolean,
    icon: Function, // lucide DownloadIcon or whatever
    pokemon: Object,  //POKEMON_DATA['porygon']
    href: String,
})


const colourClass = computed(()=> `bg-tool-${props.tool}${ props.secondary||props.tertiary ? '-'+(props.tertiary?'tertiary':'secondary'):''}`)

</script>
<template>
    <div
        class="
            text-white font-display
            inline-flex flex-row items-center
            rounded shadow-lg hover:shadow-xl
            transition-all cursor-pointer
        "
        :class="{
            'px-4 py-2 gap-2': !props.small,
            'px-2 py-1 gap-1 text-sm': !!props.small,
            [colourClass]: !subdued,
            [colourClass+'/70']: subdued,
            ['hover:'+colourClass+'/80']: true,
            ['pointer-events-none greyed-out']: props.disabled
        }"
    >
        <slot name="icon">
            <component
                v-if="props.icon"
                :is="props.icon"
                :class="{
                    'w-5 h-5': props.small
                }"
            />
            <PokemonIcon
                v-if="props.pokemon"
                class="w-8"
                :pokemon="props.pokemon"
            />
        </slot>
        <div v-if="$slots.default" class="text-center">
            <slot/>
        </div>
    </div>
</template>
